<!--
보관장소 임대장부 수정
------------------------------------
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

            <div class="uk-modal-header">
                <h4>보관장소 강제해지</h4>
            </div>

            <div class="uk-modal-body uk-padding-small uk-text-center">

                <div class="uk-text-primary uk-text-large">
                    {{ lental.storage }}
                </div>
                <div>
                    위 보관장소를 FREE 상태로 강제 변경합니다.<br />
                    실제 보관장소가 비어있는 경우에만 동작하세요
                </div>


            </div>


            <div class="uk-modal-footer uk-text-right">

                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button
                    type="button"
                    class="uk-button uk-button-danger"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: check"></span>
                    강제해지(완료)
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {
                // 임대장부 정보
                lental: {},
            };
        },
        computed: {
        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {
                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             * @param lental_id 임대장부ID
             */
            form(lental_id) {

                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/storage-lentals/' + lental_id,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.lental = response.lental;

                    // 폼띄우기
                    this.displayForm();
                });
            },

            /**
             * submit
             */
            submit() {

                // ajax 옵션
                let opts = {
                    type: 'patch',
                    url: '/storage-lentals/' + this.lental.id,
                    data: {
                        '_token': this.csrfToken,
                    },
                    success: (response, textStatus, jqXHR) => {
                        UIkit.modal.alert(response.msg).then(function () {
                            $.app.refresh();
                        });
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>